import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Header from "../../components/header/Header";
import RadioInput from "../../components/radioInput/RadioInput";
import "./CustomQuestionnaire.css";

const CustomQuestionnaire = (props) => {
  const { id, pid, prid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaved, setIsSaved] = useState(false);
  const [patientName, setPatientName] = useState("");

  useEffect(() => {
    if (props.isLogged === false) {
      localStorage.setItem("nextQuestionnaire", 1);
      navigate("/login");
    } else if (props.isTherapist){
      props.actSidebar(true);
      }
    // eslint-disable-next-line
  }, [props]);

  useEffect(() => {
    if (props.isLogged === false) {
      return;
    }

    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_questionnaires/get-questionnaire", { questionnaire_id: id })
      .then((res) => {
        if (res.data.responseData) {
          if (res.data.responseData.thisQuestCompleted !== 1) {
            setQuestionsList(res.data.responseData);
          } else {
            if (!location.pathname.split("/")[1] === "patient-assesment") {
              navigate("/landing");
            } else if (res.data.responseData.thisQuestCompleted === 1 && id === 2) {
              navigate("/landing");
            }
          }
        }
        if (location.pathname.split("/")[1] === "patient-assesment") {
          setQuestionsList(res.data.responseData);
        }
        setPage(document.getElementById("page"));
        var allBord = 106;
        for (var section of res.data.responseData.sections) {
          for (var question of section.questions) {
            allBord = allBord + question.answers.length * 2;
          }
        }
        setBorderScroll(allBord);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });

    if (pid !== undefined) {
      axios
        .post(window.ajaxLink + "cloud_therapist/user_details", { id: pid })
        .then((res) => {
          if (res.data.responseData) {
            setPatientName(res.data.responseData.patientName);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    // eslint-disable-next-line
  }, [id]);

  const [page, setPage] = useState({});
  const [borderScroll, setBorderScroll] = useState(0);
  const [questionsList, setQuestionsList] = useState({});
  const [popUp, setPopUp] = useState(false);
  const [errorQuestions, setErrorQuestions] = useState(false);
  // eslint-disable-next-line
  const [errorAnswer, setErrorAnswer] = useState("");
  const openClosePopUp = () => {
    setPopUp(!popUp);
  };
  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  const handleAns = (question, answer) => {
    if (answer.length > 200) {
      setErrorPopUp("Length cannot exceed 200 characters");
      answer = answer.substring(0, 200);
      // return;
    } else {
      setErrorPopUp("");
    }
    var answerObj = { ...answersCollection };
    answerObj[question] = answer;
    setAnswersCollection(answerObj);
  };

  const handleInputChecked = (question, answerid, answer, questions) => {
    //console.log("----", question, answerid, answer, questions);
    if (answer.length > 200) {
      setErrorPopUp("Length cannot exceed 200 characters");
      answer = answer.substring(0, 200);
      // return;
    } else {
      setErrorPopUp("");
    }

    var answerObj = { ...answersCollection };
    if (!answerObj[question]) {
      answerObj[question] = {};
    }
    answerObj[question][answerid] = answer;
    for (let outerKey in answerObj) {
      for (let innerKey in answerObj[outerKey]) {
        if (answerObj[outerKey][innerKey] === "") {
          delete answerObj[outerKey][innerKey];
        }
      }

      if (Object.keys(answerObj[outerKey]).length === 0) {
        delete answerObj[outerKey];
      }
    }
    setAnswersCollection(answerObj);
  };

  const [answersCollection, setAnswersCollection] = useState({});
  const submitAnswers = () => {
    var questNum = function () {
      var allNum = 0;
      for (var section of questionsList.sections) {
        allNum = allNum + section.questions.length;
      }
      return allNum;
    };

    if ((Object.keys(answersCollection).length === questNum() || id !== 2) && !errorPopUp) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;

      var sendData = { 
        answers: answersCollection,
        patientAssesment: false,
       };
	  
      if (!!pid && id == 25) {
        sendData["patientId"] = pid;
        sendData["patientAssesment"]= true;
      }

      axios
        .post(window.ajaxLink + "cloud_questionnaires/submit-questionnaire", sendData)
        .then((res) => {
          if (res.data.responseCode === 200) {
            setIsSaved(true);
            if (props.haveBackToLanding) {
              setTimeout(() => {
                navigate("/landing");
              }, 2000);
            } else if (!props.haveBackToLanding) {
              setTimeout(() => {
                navigate("/patient-details/" + pid + "/" + prid);
              }, 2000);
            }
          }
        })
        .catch((error) => {
          if (error.response.data.responseCode === 417) {
            setErrorPopUp(error.response.data.errorData);
          }
        });
    } else {
      setPopUp(true);
      setErrorQuestions(true);
    }
  };

  return (
    <>
    {
      !props?.isTherapist ?
    <div id="page">
      <Header />
      {(props.haveBack || props.haveBackToLanding) && (
        <div className="steps_container">
          <div
            className="previous_btn"
            onClick={() => navigate(props.haveBackToLanding ? "/landing" : "/patient-details/" + pid + "/" + prid)}
          >
            <div className="back_arrow_btn"></div>
          </div>
        </div>
      )}
      {!isLoading ? (
        <div className="formContainer customFormContainer">
          {isSaved === true && (
            <div className="prog_err_hold prog_pop_pat_correct">
              <div className="prog_pop_icon_correct prog_err_icon"></div>
              <div className="prog_err_text prog_pop_text_correct">Questionnaire successfuly saved.</div>
            </div>
          )}
          {errorAnswer !== "" && (
            <div className="prog_err_hold">
              <div className="prog_err_icon"></div>
              <div className="prog_err_text">{errorAnswer}</div>
            </div>
          )}
          <div className="customFormMainTitle">{questionsList.main_title}</div>

          {patientName ? (
            <div className="formTitle patientInfoTop">
              Patient: {patientName}
              <br />
              Date: {moment(new Date()).format("l")}
            </div>
          ) : (
            <></>
          )}

          {questionsList &&
            questionsList.sections &&
            questionsList.sections.map((section, key) => (
              <>
                <div key={key} className="formTitle customFormTitle">
                  {section.title}
                </div>
                {key === 0 && <div className="customFormDescription">{questionsList.top_instructions}</div>}
                {section.questions.map((question, q) => (
                  <div key={q}>
                    <div
                      className={"formSubtitle" + (question.question_type === "Subtitle" ? " customFormSubtitle" : "")}
                    >
                      {(question.question && question.question_number !== "0" ? question.question_number + ". " : "") +
                        question.question}
                    </div>
                    {question.answers.map((answer, a) => (
                      <>
                        {question.question_type === "Input" ? (
                          <input
                            type="text"
                            maxLength={205}
                            value={
                              answersCollection &&
                              answersCollection[question.question_id] &&
                              answersCollection[question.question_id][answer.id]
                                ? answersCollection[question.question_id][answer.id]
                                : ""
                            }
                            placeholder={answer.name}
                            className="input_field_questionare"
                            onChange={(e) =>
                              handleInputChecked(question.question_id, answer.id, e.target.value, section.questions)
                            }
                          />
                        ) : question.question_type === "radioWithInput" ? (
                          <div key={a} onClick={() => handleAns(question.question_id, answer.name)}>
                            <RadioInput
                              isChecked={
                                answersCollection &&
                                answersCollection[question.question_id] &&
                                answersCollection[question.question_id] === answer.name
                                  ? true
                                  : false
                              }
                              textValue={answer.name}
                              checkRadio={() => {
                                return;
                              }}
                              customStyle={true}
                              isInError={
                                errorQuestions && !answersCollection[question.question_id] && !question.is_optional
                              }
                            />
                          </div>
                        ) : (
                          <div key={a} onClick={() => handleAns(question.question_id, answer.name)}>
                            <RadioInput
                              isChecked={
                                answersCollection &&
                                answersCollection[question.question_id] &&
                                answersCollection[question.question_id] === answer.name
                                  ? true
                                  : false
                              }
                              textValue={answer.name}
                              checkRadio={() => {
                                return;
                              }}
                              customStyle={true}
                              isInError={
                                errorQuestions && !answersCollection[question.question_id] && !question.is_optional
                              }
                            />
                          </div>
                        )}
                      </>
                    ))}

                    {question.question_type === "radioWithInput" && (
                      <>
                        <input
                          type="text"
                          maxLength={205}
                          value={
                            answersCollection && answersCollection[question.question_id]
                              ? answersCollection[question.question_id][100]
                              : ""
                          }
                          className="input_field_questionare"
                          placeholder="Enter notes"
                          onChange={(e) =>
                            handleInputChecked(question.question_id, 100, e.target.value, section.questions)
                          }
                        />
                      </>
                    )}
                  </div>
                ))}
              </>
            ))}
          {questionsList.bottom_instructions && (
            <div className="customFormDescription">{questionsList.bottom_instructions}</div>
          )}
          <div className="next_btn_questionare" onClick={() => submitAnswers()}>
            Submit
          </div>
        </div>
      ) : (
        <div className="loader_full_container">
          <div className="p_load"></div>
        </div>
      )}
      {popUp && !(location.pathname.split("/")[1] === "patient-assesment") && (
        <div className="approval_wrapper" style={{ height: page.scrollHeight + borderScroll + "px" }}>
          <div className="approval_close" onClick={() => openClosePopUp()}></div>
          <div className="dbl_place_on_page">
            <div className="approval_popup">
              <div className="ap_title">Are you sure you want to finish this questionnaire later?</div>
              <div className="ap_explain">
                If you prefer to complete the Lower back pain questionnaire later, we will remind you by email before
                your scheduled one-on-one call with your therapist.
              </div>
              <Link to={"/landing"} style={{ textDecoration: "none" }}>
                <div className="ap_button apb_confirm">Yes, remind me</div>
              </Link>
              <div className="ap_button" onClick={() => openClosePopUp()}>
                No, go to back
              </div>
            </div>
          </div>
        </div>
      )}
      {errorPopUp && (
        <div className="prog_err_hold ">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text ">{errorPopUp}</div>
        </div>
      )}
    </div>
      :
      <div style={{width: "100%", overflow: "auto", height: "100vh"}}>
        <div className="steps_container">
          <div
            className="previous_btn"
            onClick={() => navigate("/questionnaires")}
          >
            <div className="back_arrow_btn"></div>
          </div>
        </div>
      {!isLoading ? (
        <div className="formContainer customFormContainer" style={{marginTop: "50px"}}>
          {isSaved === true && (
            <div className="prog_err_hold prog_pop_pat_correct">
              <div className="prog_pop_icon_correct prog_err_icon"></div>
              <div className="prog_err_text prog_pop_text_correct">Questionnaire successfuly saved.</div>
            </div>
          )}
          {errorAnswer !== "" && (
            <div className="prog_err_hold">
              <div className="prog_err_icon"></div>
              <div className="prog_err_text">{errorAnswer}</div>
            </div>
          )}
          <div className="customFormMainTitle">{questionsList.main_title}</div>

          {patientName ? (
            <div className="formTitle patientInfoTop">
              Patient: {patientName}
              <br />
              Date: {moment(new Date()).format("l")}
            </div>
          ) : (
            <></>
          )}

          {questionsList &&
            questionsList.sections &&
            questionsList.sections.map((section, key) => (
              <>
                <div key={key} className="formTitle customFormTitle">
                  {section.title}
                </div>
                {key === 0 && <div className="customFormDescription">{questionsList.top_instructions}</div>}
                {section.questions.map((question, q) => (
                  <div key={q}>
                    <div
                      className={"formSubtitle" + (question.question_type === "Subtitle" ? " customFormSubtitle" : "")}
                    >
                      {(question.question && question.question_number !== "0" ? question.question_number + ". " : "") +
                        question.question}
                    </div>
                    {question.answers.map((answer, a) => (
                      <>
                        {question.question_type === "Input" ? (
                          <input
                            type="text"
                            maxLength={205}
                            value={
                              answersCollection &&
                              answersCollection[question.question_id] &&
                              answersCollection[question.question_id][answer.id]
                                ? answersCollection[question.question_id][answer.id]
                                : ""
                            }
                            placeholder={answer.name}
                            className="input_field_questionare"
                            onChange={(e) =>
                              handleInputChecked(question.question_id, answer.id, e.target.value, section.questions)
                            }
                          />
                        ) : question.question_type === "radioWithInput" ? (
                          <div key={a} onClick={() => handleAns(question.question_id, answer.name)}>
                            <RadioInput
                              isChecked={
                                answersCollection &&
                                answersCollection[question.question_id] &&
                                answersCollection[question.question_id] === answer.name
                                  ? true
                                  : false
                              }
                              textValue={answer.name}
                              checkRadio={() => {
                                return;
                              }}
                              customStyle={true}
                              isInError={
                                errorQuestions && !answersCollection[question.question_id] && !question.is_optional
                              }
                            />
                          </div>
                        ) : (
                          <div key={a} onClick={() => handleAns(question.question_id, answer.name)}>
                            <RadioInput
                              isChecked={
                                answersCollection &&
                                answersCollection[question.question_id] &&
                                answersCollection[question.question_id] === answer.name
                                  ? true
                                  : false
                              }
                              textValue={answer.name}
                              checkRadio={() => {
                                return;
                              }}
                              customStyle={true}
                              isInError={
                                errorQuestions && !answersCollection[question.question_id] && !question.is_optional
                              }
                            />
                          </div>
                        )}
                      </>
                    ))}

                    {question.question_type === "radioWithInput" && (
                      <>
                        <input
                          type="text"
                          maxLength={205}
                          value={
                            answersCollection && answersCollection[question.question_id]
                              ? answersCollection[question.question_id][100]
                              : ""
                          }
                          className="input_field_questionare"
                          placeholder="Enter notes"
                          onChange={(e) =>
                            handleInputChecked(question.question_id, 100, e.target.value, section.questions)
                          }
                        />
                      </>
                    )}
                  </div>
                ))}
              </>
            ))}
          {questionsList.bottom_instructions && (
            <div className="customFormDescription">{questionsList.bottom_instructions}</div>
          )}
          <div className="next_btn_questionare" onClick={() => submitAnswers()}>
            Submit
          </div>
        </div>
      ) : (
        <div className="loader_full_container">
          <div className="p_load"></div>
        </div>
      )}
      {popUp && !(location.pathname.split("/")[1] === "patient-assesment") && (
        <div className="approval_wrapper" style={{ height: page.scrollHeight + borderScroll + "px" }}>
          <div className="approval_close" onClick={() => openClosePopUp()}></div>
          <div className="dbl_place_on_page">
            <div className="approval_popup">
              <div className="ap_title">Are you sure you want to finish this questionnaire later?</div>
              <div className="ap_explain">
                If you prefer to complete the Lower back pain questionnaire later, we will remind you by email before
                your scheduled one-on-one call with your therapist.
              </div>
              <Link to={"/landing"} style={{ textDecoration: "none" }}>
                <div className="ap_button apb_confirm">Yes, remind me</div>
              </Link>
              <div className="ap_button" onClick={() => openClosePopUp()}>
                No, go to back
              </div>
            </div>
          </div>
        </div>
      )}
      {errorPopUp && (
        <div className="prog_err_hold ">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text ">{errorPopUp}</div>
        </div>
      )}
    </div>
    }
    </>
  );
};

export default CustomQuestionnaire;
